import * as yup from "yup";

const bankTransferSchema = yup.object().shape({
  amount: yup.string().required("Amount is required"),
  bankName: yup.string().required("Bank Name is required"),
  accountType: yup.string().required("Account Type is required"),
  accountName: yup.string().required("Account Name is required"),
  accountNumber: yup.string().required("Account Number is required"),
});
const cryptoTransferSchema = yup.object().shape({
  amount: yup.string().required("Amount is required"),
  crypto: yup.string().required("Please put your in coin or crypto"),
  network: yup.string().required("Network is required"),
  walletAddress: yup.string().required("Wallet Address is required"),
});

export const getTransferSchema = (payoutOption) => {
  switch (payoutOption) {
    case "Bank Transfer":
      return bankTransferSchema;
    case "Crypto Transfer":
      return cryptoTransferSchema;
    default:
      return yup.object().shape({});
  }
};

export const sendOtherdataStill = (option, data) => {
  data.transactiontype = option;
  if (option === "Crypto Transfer") {
    data.bankName = data.crypto;
    data.accountName = data.crypto;
    data.accountNumber = data.network;
    data.accountType = data.network;
  } else {
    data.walletAddress = data.bankName;
    data.crypto = data.accountName;
    data.network = data.accountType;
  }
};
